import '../../lang/i18n';
import { useTranslation } from 'react-i18next';
import React, {useState, useEffect } from "react";
import { useParams } from "react-router";
import Api from "../../services/Api";
import LocalBreadcrumbs from "../../components/Breadcrumbs/LocalBreadcrumbs";
import {ClientInterface} from "../../interfaces/common";
import Chat from "../../components/Chat/Chat";

export default function ClientChatPage() {

  const api = Api.getInstance();
  const translation = useTranslation();
  const { t } = translation;
  const { clientId } = useParams();
  const [client, setClient] = useState<ClientInterface>()
  const [loaded, setLoaded] = useState<boolean>(false)

  useEffect(() => {
    api.get('coach/client/' + clientId).then((result) => {
      setClient(result.json.client)
      setLoaded(true)
    })
  }, [])

  if (!loaded) {
    return (<div className="mt-4">Loading clients...</div>)
  }

  const crumbs = [
    { name: 'Chat', url: '/chats'},
    { name: client?.firstName + " " + client?.lastName, url: '/clients/' + clientId }
  ]

  return (
    <div className="main-content">
      <LocalBreadcrumbs crumbs={crumbs}/>
      <div className="rounded" style={{height: "calc(100vh - 200px)"}}>
        <Chat clientId={client?.id} isCoach={true}/>
      </div>
    </div>
  )
};